import { FetchStatus } from '../types';
import { SignInArgs, RefreshArgs } from '../api/user';

export enum XAuthAction {
  SIGN_IN = 'SIGN_IN',
  SIGN_OUT = 'SIGN_OUT',
  SET_USER_DATA = 'SET_USER_DATA',
  SET_USER_FETCH_STATUS = 'SET_USER_FETCH_STATUS',
  CHECK_LS_JWT = 'CHECK_LS_JWT',
  REFRESH_CURRENT_USER_TOKEN = 'REFRESH_CURRENT_USER_TOKEN',
  REFRESH_USER_TOKEN = 'REFRESH_USER_TOKEN'
}

interface SetUserDataAction {
  data: any;
  jwt: string;
  refreshToken: string;
}

export const setUserData = ({
  data,
  jwt,
  refreshToken
}: SetUserDataAction) => ({
  type: XAuthAction.SET_USER_DATA,
  payload: {
    data,
    jwt,
    refreshToken
  }
});

export const setUserFetchStatus = (status: FetchStatus) => ({
  type: XAuthAction.SET_USER_FETCH_STATUS,
  payload: status
});

export const signInUser = (payload: SignInArgs) => ({
  type: XAuthAction.SIGN_IN,
  payload
});

export const refreshUserToken = (
  currentRefreshTokens: RefreshArgs,
  onSuccess?: () => void
) => ({
  type: XAuthAction.REFRESH_USER_TOKEN,
  payload: currentRefreshTokens,
  meta: { onSuccess }
});

export const refreshCurrentUserToken = (onSuccess?: () => void) => ({
  type: XAuthAction.REFRESH_CURRENT_USER_TOKEN,
  meta: { onSuccess }
});

export const signOutUser = () => ({ type: XAuthAction.SIGN_OUT });

export const tryLoginWithLsJwt = () => ({ type: XAuthAction.CHECK_LS_JWT });
